<template>
  <v-container
    fluid
    class="d-flex align-center justify-center fill-height pa-0 h-screen"
    style="background: linear-gradient(135deg, #10B98155, #1583D455);" 
  >
    <v-card
      elevation="18"
      width="450"
      class="pa-10 rounded-xl"
      style="background-color: #ffffff;"
    >
      <!-- Header -->
      <div class="text-center mb-8">
        <h2 class="text-h4 font-weight-bold" style="color:#1583D4;"> 
          Varanda Imóveis RP
        </h2>
        <p class="text-body-2 text-gray-600 mt-2">
          Gerencie as propriedades e clientes com eficiência.
        </p>
      </div>

      <!-- Formulário -->
      <v-form @submit.prevent="login" ref="formRef">
        <v-text-field
          v-model="email"
          label="E-mail"
          type="email"
          prepend-inner-icon="mdi-email-outline"
          variant="outlined"
          required
          class="mb-4"
          :style="{ '--v-theme-primary': emerald }" 
        />

        <v-text-field
          v-model="password"
          :type="passwordVisible ? 'text' : 'password'"
          label="Senha"
          prepend-inner-icon="mdi-lock-outline"
          variant="outlined"
          required
          :append-inner-icon="passwordVisible ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append-inner="passwordVisible = !passwordVisible"
          class="mb-6"
          :style="{ '--v-theme-primary': emerald }" 
        />

        <!-- Botão de login -->
        <v-btn
          type="submit"
          block
          size="large"
          class="text-white"
          :loading="loading"
          :disabled="loading"
          style="background-color:#1583D4; font-weight:600;" 
        >
          Entrar
        </v-btn>
      </v-form>

      <!-- Toast -->
      <v-snackbar
        v-model="toast.show"
        :color="toast.color === 'error' ? '#EF4444' : '#10B981'" 
        timeout="3000"
        location="top"
        variant="tonal"
      >
        {{ toast.message }}
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref } from "vue"
import { useRouter } from "vue-router"
import { useStore } from "vuex"

const email = ref("")
const password = ref("")
const passwordVisible = ref(false)
const loading = ref(false)
const emerald = "#10B981" // Verde esmeralda
const toast = ref({
  show: false,
  message: "",
  color: "error",
})

const router = useRouter()
const store = useStore()

const login = async () => {
  if (!email.value || !password.value) {
    showToast("Por favor, preencha todos os campos.", "error")
    return
  }

  loading.value = true
  try {
    const response = await store.dispatch("postLogin", {
      email: email.value,
      password: password.value,
    })

    if (!response.user || !response.token) {
      showToast("Erro ao recuperar dados da empresa ou usuário.", "error")
      loading.value = false
      return
    }

    router.push("/app/dashboard")
  } catch (error) {
    console.error(error.error)
    showToast(error?.response?.data?.error || error.error, "error")
  } finally {
    loading.value = false
  }
}

const showToast = (message, color = "error") => {
  toast.value = {
    show: true,
    message,
    color,
  }
}
</script>
